module.exports = __webpack_public_path__ + "img/1566117600.1534f6cb.jpg";